"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableList = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _Button = require("../../UI/Button");
var _Icon = require("../../UI/Icon");
var _ExpandableList = require("./ExpandableList.styles");
var _ExpandableList2 = require("./ExpandableList.labels");
var _jsxRuntime = require("react/jsx-runtime");
const ExpandableList = props => {
  const {
    items = [],
    ItemTag,
    isWithRemoveAllButton = false,
    onRemoveAllItems
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const {
    outerDivRef,
    contentRef,
    extraRef,
    visibleChildren,
    hiddenChildren
  } = (0, _hooks.useListChildren)(items, isMobileView);
  const getLabel = (0, _hooks.useLabels)({
    labels: _ExpandableList2.labels
  });
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const [isTransitionInMotion, setIsTransitionInMotion] = (0, _react.useState)(false);
  const isOpenBtnVisible = hiddenChildren.length > 0;
  const styles = (0, _ExpandableList.useStyles)(props, isTransitionInMotion, isExpanded || isMobileView, isOpenBtnVisible);
  const handleRemoveAllItems = () => {
    if (onRemoveAllItems) {
      onRemoveAllItems();
    }
  };
  const handleOpenBtnClick = () => {
    setIsExpanded(true);
    setIsTransitionInMotion(true);
  };
  const handleCloseBtnClick = () => {
    setIsExpanded(false);
    setIsTransitionInMotion(true);
  };
  const handleTransitionEnd = () => {
    setIsTransitionInMotion(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-ExpandableList'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-ExpandableList__content'],
      ref: outerDivRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
        className: styles['cc-ExpandableList__items'],
        ref: contentRef,
        onTransitionEnd: handleTransitionEnd,
        "data-testid": "ccExpandableList",
        children: [visibleChildren.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: styles['cc-ExpandableList__item'],
          "data-is-visible": "true",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemTag, {
            ...item
          })
        }, `item_visible_${index}`)), (isExpanded || isTransitionInMotion) && hiddenChildren.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: styles['cc-ExpandableList__item'],
          "data-is-visible": "true",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemTag, {
            ...item
          })
        }, `item_hidden_${index}`))]
      }), items.length > 0 && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ExpandableList__open'],
        ref: extraRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccExpandableListOpenBtn",
          onClick: handleOpenBtnClick,
          view: "link",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: styles['cc-ExpandableList__btn'],
            children: `+ ${hiddenChildren.length} ${getLabel('open_btn')}`
          })
        })
      }), items.length > 0 && isWithRemoveAllButton && isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ExpandableList__remove-all'],
        ref: extraRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccExpandableListRemoveAllBtn",
          onClick: handleRemoveAllItems,
          view: "alternate",
          color: "primary",
          shape: "round",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Trash",
            width: "20",
            height: "20"
          })
        })
      })]
    }), items.length > 0 && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-ExpandableList__close'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccExpandableListCloseBtn",
        onClick: handleCloseBtnClick,
        view: "link",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-ExpandableList__btn'],
          children: getLabel('close_btn')
        })
      })
    })]
  });
};
exports.ExpandableList = ExpandableList;